export class SpecialityParent {
  constructor() {
    this.list = []
  }

  addSpeciality(item) {
    this.list.push(Speciality.buildFromAPI(item))
  }

  updateSpeciality(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, Speciality.buildFromAPI(item))
  }

  removeSpeciality(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => Speciality.buildFromAPI(el))
    }
    return this
  }
}

export class Speciality {
  constructor() {
        this.id = null
        this.name = null
        this.shortName = null
        this.code = null
      }

  getForAPI() {
    return {
            id: this.id,
            name: this.name,
            shortName: this.shortName,
            code: this.code,
          }
  }

  static buildFromAPI(obj) {
    const _this = new Speciality()
    if (obj) {
            _this.id = obj.id
            _this.name = obj.name
            _this.shortName = obj.shortName
            _this.code = obj.code
          }
    return _this
  }
}